module.exports = __webpack_public_path__ + "static/media/variants-display-guide.7afcc004.png";